export const palacioMeta = [
  { label: 'Role', value: 'UX Lead, credit' },
  { label: 'Team', value: 'Me + 2 designers (UX, UI)' },
  { label: 'Timeline', value: '11 months · 2023' },
  { label: 'Platform', value: 'iOS & Android' },
];

export const palacioStats = [
  { value: '5.0', label: 'App Store rating' },
  { value: '50K+', label: 'downloads' },
  { value: 'Top 10', label: 'finance apps in Mexico' },
  { value: '11 mo', label: 'from kickoff to launch' },
];

export const palacioWorkingStyle = [
  {
    title: 'Co-creation workshops',
    body: 'I sketched wireframes live with the client, so decisions were made in the room instead of in review cycles.',
  },
  {
    title: 'Credit from zero',
    body: 'There was no digital credit experience to start from. I defined the flows and information architecture from scratch.',
  },
  {
    title: 'Leading two designers',
    body: 'I handed most of the detailed UX work to one designer and coached the other to keep the UI consistent with the existing ecommerce site.',
  },
];

export const palacioDecisions = [
  {
    letter: 'A',
    title: 'A neutral home screen',
    body: 'The home screen gives marketing and credit each a clear, balanced zone. Neither side lost the space, which ended the turf war and let both teams ship.',
  },
  {
    letter: 'B',
    title: 'Navigation that changes with login',
    body: 'The bottom nav adapts to login state, so guests see shopping first and cardholders get their credit tools one tap away.',
  },
  {
    letter: 'C',
    title: 'Pivoting to white-label to hit the date',
    body: "A fully agnostic build wouldn't fit the timeline. We moved to a white-label approach and kept the launch date.",
  },
];
